// extracted by mini-css-extract-plugin
export default {"container":"NavItem_container__jJwxY","icon":"NavItem_icon__fsQTT","title":"NavItem_title__NFoBV","active":"NavItem_active__WQLM+"};